"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reporter = void 0;
const ioTSReporters = require("io-ts-reporters");
// because the type in io-ts-reporters is wrong
function reporter(validation) {
    return ioTSReporters.reporter(validation);
}
exports.reporter = reporter;
//# sourceMappingURL=validation.js.map